export default "__VITE_ASSET__C9$9g7mh__";